import { render, staticRenderFns } from "./CmgOverlay.vue?vue&type=template&id=328f9812&scoped=true&lang=pug&"
import script from "./cmg-overlay.ts?vue&type=script&lang=ts&"
export * from "./cmg-overlay.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOverlay.vue?vue&type=style&index=0&id=328f9812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328f9812",
  null
  
)

export default component.exports